// src/components/ClickableIcon/ClickableIcon.js
import React from "react";
import "./ClickableIcon.css";

const ClickableIcon = ({ icon, url, href, label, color, download }) => {
  const link = href || url; // accepte les deux

  const linkProps = {
    href: link,
    "aria-label": label,
    className: "clickable-icon",
    style: color ? { backgroundColor: color } : undefined,
  };

  // si on passe "download", on ne met pas target="_blank"
  if (download) {
    linkProps.download = download;
  } else {
    linkProps.target = "_blank";
    linkProps.rel = "noopener noreferrer";
  }

  return <a {...linkProps}>{icon}</a>;
};

export default ClickableIcon;
